export const defaultViewMeta = {
  name: 'default',
};
